import Key from "../../clientVariables.json";

export const fetchAdvancedOptimize = async (jobDescription, candidateData) => {
  const url = `${Key.domain.replace(/\/+$/, "")}/ai-search/advanced-optimize`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-api-key": Key.apiKey,
    },
    body: JSON.stringify({ jobDescription, candidateData }),
  });

  let body = null;
  try {
    body = await response.json();
  } catch {
    body = null;
  }

  if (!response.ok) {
    const message =
      body?.message || body?.error || `Request failed with status ${response.status}`;
    throw new Error(message);
  }

  if (!body?.success || !body?.optimizedData) {
    throw new Error(body?.message || "Invalid response from advanced optimize API");
  }

  return body.optimizedData;
};
